import { Component, inject, input } from '@angular/core';
import { Product, ProductComponent } from '../product/product.component';
import { LanguageService } from '../../../services/language.service';
import { DOMHandlerService } from '../../../services/domhandler.service';
import { Router, RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { UmamiService } from '../../../services/umami.service';

@Component({
    selector: 'app-bestsellers',
    imports: [ProductComponent, RouterLink, TranslatePipe],
    host: {
        class: '~p-8/12 flex justify-end h-[95%] md:h-full flex-col gap-4 relative',
    },
    templateUrl: './bestsellers.component.html',
})
export class BestsellersComponent {
    data = input.required<Bestsellers>();
    languageService = inject(LanguageService);
    domHandler = inject(DOMHandlerService);
    umami = inject(UmamiService);
    private router = inject(Router);

    navigateToProduct(product: Product) {
        this.umami.track('product-click');
        this.router.navigate([
            `/${this.languageService.getLanguageCode}/hof/produkt/${product.slug}`,
        ]);
    }
}

export type Bestsellers = {
    title: string;
    products: Product[];
};
